<template lang="pug">
.d-flex
  .flex-grow-1
    filter-name.mr-2(ref="name" :filter.sync="nameFilter" check-initial-value)
    filter-price(ref="price" :filter.sync="priceFilter" check-initial-value)
  v-btn.button-sm.underline.px-0(text @click="resetFilters" :disabled="allFilters.length === 0") Reset filters
</template>

<script>
import FilterName from '@/components/module/filter/FilterName.vue'
import FilterPrice from '@/components/module/filter/FilterPrice.vue'

export default {
  name: 'FilterServicesRow',
  components: { FilterName, FilterPrice },
  props: ['filters', 'propFilters'],
  data: () => ({
    nameFilter: {},
    priceFilter: {},
  }),
  computed: {
    allFilters () {
      const filters = []
      if (this.nameFilter.key) {
        filters.push(this.nameFilter)
      }
      if (this.priceFilter.key) {
        if (this.priceFilter.key === 'between') {
          const values = this.priceFilter.value
          for (const i in values) {
            filters.push(values[i])
          }
        } else {
          filters.push(this.priceFilter)
        }
      }
      return filters
    },
    dataFilters () {
      return {
        nameFilter: this.nameFilter,
        priceFilter: this.priceFilter,
      }
    }
  },
  watch: {
    allFilters (newValue) {
      this.$emit('update:filters', newValue)
    }
  },
  methods: {
    setFilters () {
      this.nameFilter = this.propFilters?.nameFilter || {}
      this.priceFilter = this.propFilters?.priceFilter || {}
      this.$nextTick(() => {
        this.$refs.name.setData()
        this.$refs.price.setData()
      })
    },
    resetFilters () {
      this.nameFilter = {}
      this.priceFilter = {}
    }
  }
}
</script>